 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		45: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"6efeebd5008bf5e046c27708656176cec069d32a","2":"b637e9a5","3":"component---src-templates-event-singular-tsx","4":"b1b463f58b5e599c686aa4afda4f94a2afab0c54","5":"0b7b90cd","6":"1e0e1e1ce24732d582f3c2e6cc878c4206da2334","7":"component---src-pages-products-bare-metal-cloud-tsx","8":"67d02f1e27459dbd9756319bf5aa76dc2a497d5f","9":"component---src-pages-index-tsx","10":"component---src-pages-about-us-tsx","11":"component---src-pages-customer-stories-tsx","12":"component---src-pages-products-cloud-wan-tsx","13":"component---src-pages-solutions-china-tsx","14":"component---src-pages-solutions-gaming-tsx","15":"5e88fd55","17":"component---src-pages-404-tsx","18":"component---src-pages-by-the-numbers-china-tsx","19":"component---src-pages-by-the-numbers-india-tsx","20":"component---src-pages-careers-tsx","21":"component---src-pages-contact-us-tsx","22":"component---src-pages-ethics-and-compliance-tsx","23":"component---src-pages-gameeq-tsx","24":"component---src-pages-legal-tsx","25":"component---src-pages-partners-channel-partner-tsx","26":"component---src-pages-partners-reseller-partner-tsx","27":"component---src-pages-partners-solutions-partner-tsx","28":"component---src-pages-products-cloud-networking-tsx","29":"component---src-pages-products-content-delivery-network-tsx","30":"component---src-pages-products-edge-data-center-services-tsx","31":"component---src-pages-products-ip-transit-tsx","32":"component---src-pages-products-professional-services-tsx","33":"component---src-pages-service-level-agreement-tsx","34":"component---src-pages-solutions-cloud-service-providers-tsx","35":"component---src-pages-solutions-hybrid-cloud-tsx","36":"component---src-pages-solutions-media-entertainment-tsx","37":"component---src-pages-support-tsx","38":"component---src-pages-widget-footer-tsx","39":"component---src-pages-widget-speed-test-tsx","40":"component---src-templates-customer-story-tsx","41":"component---src-templates-dc-tsx","42":"component---src-templates-documentation-tsx","43":"component---src-templates-event-tsx"}[chunkId]||chunkId) + "-" + {"1":"c1cea451a870c8882e13","2":"3e8037b8c3a7ee5b4ae3","3":"a6dba2cfe5558baf713c","4":"32845f43e7b5c2557c6e","5":"c21aca22f7e297c6286d","6":"bc2096b1cb5599f653f5","7":"4e486758ec38c2e8dd53","8":"d329cff4c8c9d7029466","9":"436dbf51f78b78aedc7e","10":"56a1a810594b46c25347","11":"5320b8ca1c83cbfc6978","12":"2bfe61305ee678eaba0a","13":"667317ec5c90797e8a50","14":"33bdc24d0496fa159292","15":"11737e62b250496a0507","17":"7508d516341d4cd5e02a","18":"f146ebd82425dea84ded","19":"05802ff4f842c040ac4e","20":"b7f97aa5f05d1124486f","21":"01f453b2505a3105afce","22":"58a2920ef40dcc39d0af","23":"819d8216cbe8b8b18534","24":"2bd1e5d65acc0387f039","25":"f107107c783b7dfcafc4","26":"32ec56b9d2469965d6ac","27":"981752dac8115bf0ef66","28":"4d0e6d334e02964094c7","29":"ae46e9557994592efd9d","30":"8eb742ba2f8c5fb08042","31":"0e5567db2cf1a2bd5f27","32":"b99b85c6ba66d4964bfb","33":"b0d6d4174b211c1140c4","34":"7b1838ec3566798857b1","35":"536207c630a3262b6b1c","36":"4f16a7fc0ba158dc10e6","37":"aadd77f6a0d5a115444d","38":"b75accedfc7e134690ee","39":"1eeb559a269794b1fc19","40":"b308e059b22dd5e09d95","41":"094aa5dc70283a789759","42":"f01176768e385f07c4ed","43":"f21f030fe31237ea0cf3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
